const STATUS_LABELS: Record<string, string> = {
  submitted: "Submitted",
  under_review: "Under Review",
  management_review: "Management Review",
  resubmission_required: "Needs Applicant Correction",
  finance_review: "Finance Review",
  approved_for_disbursement: "Approved For Disbursement",
  disbursed: "Payment Completed",
  rejected: "Not Selected",
  closed: "Closed",
};

const ACTION_LABELS: Record<string, string> = {
  DDO_REVIEW: "Start DDO Review",
  DDO_REJECT: "Reject During DDO Review",
  DDO_REQUEST_RESUBMISSION: "Request Applicant Correction",
  DDO_SEND_TO_MANAGEMENT: "Send To Management Review",
  MGMT_APPROVE: "Complete Management Review",
  MGMT_REJECT: "Reject During Management Review",
  FINANCE_APPROVE: "Mark Ready For Disbursal",
  FINANCE_REJECT: "Return From Finance Review",
  FINANCE_DISBURSE: "Record Payment Completed",
  VETO_APPROVE: "Record Veto Approval",
  VETO_REJECT: "Record Veto Rejection",
  STUDENT_RESUBMIT: "Submit Applicant Corrections",
};

const READINESS_LABELS: Record<string, string> = {
  pilot_observability_ready: "Ready For Internal Pilot Monitoring",
  production_observability_ready: "Ready For Production Observability",
  can_accept_real_submissions: "External Applicant Intake Allowed",
  external_student_intake_enabled: "External Applicant Intake Enabled",
  ready_for_launch: "Publication Ready",
};

export function humanizeToken(value: string | null | undefined): string {
  if (!value) return "-";
  return value
    .replaceAll("_", " ")
    .replaceAll("-", " ")
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function formatWorkflowStatusLabel(status: string | null | undefined): string {
  if (!status) return "-";
  const normalized = status.toLowerCase();
  return STATUS_LABELS[normalized] ?? humanizeToken(status);
}

export function formatWorkflowActionLabel(code: string): string {
  return ACTION_LABELS[code] ?? humanizeToken(code);
}

export function formatReadinessLabel(value: string | null | undefined): string {
  if (!value) return "-";
  const normalized = value.toLowerCase();
  return READINESS_LABELS[normalized] ?? humanizeToken(value);
}

export function financeReviewCompleteLabel(): string {
  return "Finance Review Complete";
}

export function awaitingDisbursalLabel(): string {
  return "Awaiting Disbursal";
}

export function paymentCompletedLabel(): string {
  return "Payment Completed";
}
